import { app } from '../../../bootstrap/core';
import feedbackComponent from './feedback.component';
import { FeedbackModel } from './feedback.model';
import { FeedbackService } from './feedback.service';

app.component('feedbackComponent', feedbackComponent);
app.factory('FeedbackModel', () => FeedbackModel);
app.service('feedbackService', FeedbackService);



// WEBPACK FOOTER //
// ./src/app/common/ui/feedback/feedback.js